import { useContext } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import Button from '../../common/Button';
import CdnImage from '../../common/CdnImage';
import { H3, H6 } from '../../text';
import Utils from '../../../common/Utils';
import LayoutContext from '../../../contexts/Layout';

export const AlternatingTextPlusImage = ({
    buttonColor,
    buttonText,
    buttonTextColor,
    description,
    followContentLink,
    heading,
    image,
    link,
    nodeTypeAlias = 'AlternatingTextPlusImage',
    order,
    references,
    width,
    hardWidth
}) => {
    const { layout } = useContext(LayoutContext);

    if (!image) {
        return null;
    }

    return (
        <View
            style={{
                backgroundColor: '#f7f8f9',
                flexDirection: layout.device.isMobile ? 'column' : order % 2 ? 'row' : 'row-reverse'
            }}
            dataSet={{ umbracoComponentName: nodeTypeAlias }}
        >
            <CdnImage
                uri={image.cdnImagePath}
                style={{ objectFit: 'contain', objectPosition: 'top' }}
                wrapperStyle={{ flex: 1 }}
                width={layout.device.isMobile ? Math.floor(width) : Math.floor(width * 0.5)}
            />
            <View style={{ width: layout.device.isMobile ? Math.floor(width) : Math.floor(width * 0.5) }}>
                <View
                    style={{
                        flex: layout.device.isMobile ? undefined : 1,
                        marginHorizontal: Math.floor(layout.styleGuide.spacer1 * 2),
                        marginVertical: layout.styleGuide.spacer2
                    }}
                >
                    {!!heading && <H3 style={{ marginBottom: layout.styleGuide.spacer3 }} text={heading} />}
                    {!!description && <H6 numberOfLines={25} style={{ color: '#7f868b', marginBottom: layout.styleGuide.spacer2 }} text={description} />}
                    {!!buttonText && (
                        <Button
                            onPress={async () => await followContentLink(link.isExternal, link.internalKey, link.externalUrl, references)}
                            style={{ backgroundColor: buttonColor }}
                            text={buttonText}
                            textStyle={{ color: buttonTextColor ? Utils.applyColor(buttonTextColor) : '#7f868b' }}
                        />
                    )}
                </View>
            </View>
        </View>
    );
};

AlternatingTextPlusImage.propTypes = {
    buttonColor: PropTypes.string,
    buttonText: PropTypes.string,
    buttonTextColor: PropTypes.string,
    description: PropTypes.string,
    followContentLink: PropTypes.func,
    heading: PropTypes.string,
    id: PropTypes.string,
    image: PropTypes.shape({
        cdnImagePath: PropTypes.string
    }),
    link: PropTypes.shape({
        externalUrl: PropTypes.string,
        internalKey: PropTypes.string,
        isExternal: PropTypes.bool
    }),
    order: PropTypes.number,
    references: PropTypes.object,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
